module.exports = __webpack_public_path__ + "static/media/Artboard 2.ffaee972.png";